var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBdLogoMobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 101 80",
    style: {
      enableBackground: "new 0 0 101 80"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M59.9,20c0-11-9-20-20-20s-20,9-20,20s9,20,20,20S59.9,31,59.9,20",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9,60c0-11-9-20-20-20s-20,9-20,20s9,20,20,20S59.9,71,59.9,60",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.7,7.2C76,2.5,68,0,59.9,0v80c22.1,0,40-18,40-40C99.8,26.9,93.4,14.6,82.7,7.2",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 0,
    width: 20,
    height: 80,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91,5c0-2.8,2.2-5,5-5s5,2.2,5,5s-2.2,5-5,5S91,7.8,91,5z M96,1.1c-2.1,0-3.7,1.7-3.7,3.8c0,0.1,0,0.1,0,0.2 c-0.1,2,1.5,3.8,3.5,3.9c2,0.1,3.8-1.5,3.9-3.5c0-0.1,0-0.3,0-0.4c0.1-2.1-1.5-3.8-3.5-3.9C96.1,1.1,96.1,1.1,96,1.1z M95.1,7.8 h-1.1V2.2h2.1c1.4,0,2.1,0.4,2.1,1.6c0.1,0.7-0.4,1.4-1.2,1.5c0,0-0.1,0-0.1,0l1.3,2.4H97l-1.2-2.4h-0.7L95.1,7.8z M95.1,4.5h0.9 c0.8,0,1.1-0.3,1.1-0.8S96.8,3.1,96,3.1h-0.9L95.1,4.5z",
    fill: "#FFF"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBdLogoMobile);
export default __webpack_public_path__ + "static/media/bd-logo-mobile.2546b67165f2d58856534e781e70553e.svg";
export { ForwardRef as ReactComponent };